<script>
export default {
  props: {
    params: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      excludeOffices: [],
    };
  },
  computed: {
    filteredLocations() {
      if (!this.params) return;
      return (this.params || [])
        ?.filter((el) => {
          return el?.settings?.same_day_appt;
        })
        ?.filter((el) => {
          return !this.excludeOffices.includes(el?.location_id);
        });
    },
    hasLocations() {
      if (!this.filteredLocations) return;
      return this.filteredLocations.length > 0;
    },
  },
  methods: {
    onFilterLocations(value) {
      if (!value) return;
      this.excludeOffices.push(value);
    },
  },
  render() {
    return this.$scopedSlots.default({
      filteredLocations: this.filteredLocations,
      hasLocations: this.hasLocations,
      onFilterLocations: this.onFilterLocations,
    });
  },
};
</script>
